// アンケート送信完了の画面 (spec: docs/superpowers/specs/2026-07-26-survey-completion-screen-design.md §5)。
//
// 表示専用にしてある。読み上げは呼び出し側 (ChatScreen の handleSubmit) が 1 回鳴らす。
// ここに読み上げを持たせると、リロード復元でも mount のたびに鳴ってしまう。
//
// ヘッダーもマイクも入力欄も描画しない (spec D1)。送信しても画面の構造が回答中と同じだと
// 「終わった」と伝わらず、残ったマイクが「まだ何か答えるのか」と読めてしまうため。
type Props = {
  answered: number;
  total: number;
  /** 渡されたときだけ「もう一度回答する」を表示する (リロード復元の経路のみ、spec D7) */
  onRestart?: () => void;
};

export function Completion({ answered, total, onRestart }: Props) {
  const allAnswered = answered >= total;
  return (
    <div className="mx-auto w-full max-w-2xl flex flex-col flex-1 min-h-0 bg-slate-50 overflow-y-auto">
      <div className="flex-1 px-6 py-10 flex flex-col items-center justify-center text-center">
        <div
          className="w-16 h-16 rounded-full bg-emerald-50 border border-emerald-200 grid place-items-center text-3xl text-emerald-600 mb-5"
          aria-hidden="true"
        >
          ✓
        </div>
        <h1 className="text-[17px] font-bold text-slate-900 mb-4">ご回答ありがとうございました</h1>
        <div className="flex items-center gap-2 mb-4">
          <span className="flex gap-1" aria-hidden="true">
            {Array.from({ length: total }).map((_, i) => (
              <span
                key={i}
                data-role="tally-dot"
                data-filled={i < answered ? "1" : "0"}
                className={
                  "block w-2 h-2 rounded-full " +
                  // 未回答は淡い輪郭だけにする。警告色は使わない (spec D8)
                  (i < answered ? "bg-emerald-600" : "border-[1.5px] border-slate-300")
                }
              />
            ))}
          </span>
          <span className="text-xs font-semibold text-slate-700">
            {allAnswered ? `${total} 問すべて完了` : `${total} 問中 ${answered} 問に回答`}
          </span>
        </div>
        <p className="text-[13px] leading-relaxed text-slate-700">
          {!allAnswered && (
            <>
              いただいた分はすべて受け付けました。
              <br />
            </>
          )}
          アンケートはこれで終了です。
          <br />
          画面を閉じていただいて大丈夫です。
        </p>
        {onRestart && (
          <>
            {/* min-h-[44px] は Apple HIG のタップ領域 (py-2 だけでは 36px) */}
            <button
              type="button"
              onClick={onRestart}
              className="mt-6 min-h-[44px] inline-flex items-center justify-center px-6 py-2 rounded-full text-sm font-semibold bg-indigo-600 text-white hover:bg-indigo-700"
            >
              もう一度回答する
            </button>
            <p className="mt-3 text-xs text-slate-500">別の方が続けて試すときに使います</p>
          </>
        )}
      </div>
    </div>
  );
}
